export default __webpack_public_path__ + "static/media/port2.a4429832.png";